<template>
  <viewer-form :can-edit="isSuperVisor" :can-back="true" @submit.prevent="toEditor" @back="toList">
    <text-browse-item label="氏名" :value="name" />
    <text-browse-item label="氏名（カナ）" :value="nameKana" />
    <switch-browse-item label="管理者" :checked="is_supervisor" />
    <text-browse-item label="メールアドレス" :value="email" />
    <switch-browse-item label="２段階認証" :checked="use_two_step_authentication" />
    <textarea-browse-item label="連絡先" :value="contact" />
    <text-browse-item label="店舗名" :value="office" />
    <text-browse-item label="部署名" :value="department" />
    <select-browse-item label="ステータス" :value="status" :options="this.$constant.BROKER_STATUS_LIST" />
  </viewer-form>
</template>
<script>
import {mapState} from 'vuex';
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent'
import ViewerForm from "@/views/templates/forms/ViewerForm";
import TextBrowseItem from "@/views/molecules/browseItems/TextBrowseItem";
import SwitchBrowseItem from "@/views/molecules/browseItems/SwitchBrowseItem";
import TextareaBrowseItem from "@/views/molecules/browseItems/TextareaBrowseItem";
import SelectBrowseItem from "@/views/molecules/browseItems/SelectBrowseItem";

export default {
  name: 'BrokerViewer',
  components: {
    ViewerForm,
    TextBrowseItem,
    SwitchBrowseItem,
    TextareaBrowseItem,
    SelectBrowseItem,
  },
  mixins: [AddonLoadPageEvent],
  inject: [
    '$constant'
  ],
  computed: {
    ...mapState('broker_form', {
      name: state => state.data.name,
      nameKana: state => state.data.name_kana,
      email: state => state.data.email,
      contact: state => state.data.contact,
      office: state => state.data.office,
      department: state => state.data.department,
      is_supervisor: state => state.data.is_supervisor,
      status: state => state.data.status,
      use_two_step_authentication: state => state.data.use_two_step_authentication,
    }),
    ...mapState('account', {
      isSuperVisor: state => state.is_supervisor,
    }),
  },
  methods: {
    loadPage() {
      return this.$store.dispatch('broker_form/load', {id: this.$route.params.id}).then(() => {
        this.$root.showFlashMessage();
      }).catch(() => this.$root.failApi());
    },
    toList() {
      this.$router.push({name: 'BrokerList'});
    },
    toEditor() {
      this.$router.push({name: 'BrokerEditor'});
    }
  }
}
</script>
